import React, { useState } from 'react';
import { post } from '../utils/api';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Get token from URL
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.message || 'Reset failed — the link may have expired');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <h1>Invalid Link</h1>
          <p style={{color:'#991B1B', fontSize:'14px'}}>
            This password reset link is invalid. Please request a new one.
          </p>
          <a href="/forgot-password" className="btn btn-primary" style={{display:'inline-block', marginTop:'16px', textDecoration:'none', textAlign:'center'}}>
            Request New Link
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Set New Password</h1>
        {done ? (
          <>
            <p style={{color:'#065F46', backgroundColor:'#ECFDF5', padding:'12px', borderRadius:'6px', fontSize:'14px'}}>
              Your password has been reset successfully. You can now sign in with your new password.
            </p>
            <a href="/login" className="btn btn-primary" style={{display:'inline-block', marginTop:'16px', textDecoration:'none', textAlign:'center', width:'100%'}}>
              Sign In
            </a>
          </>
        ) : (
          <>
            <p style={{color:'#6B7280', fontSize:'14px', marginBottom:'20px'}}>
              Choose a new password for your account.
            </p>
            {error && <div className="form-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Minimum 8 characters"
                  required
                  minLength={8}
                />
              </div>
              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Re-enter your password"
                  required
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%'}}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
